module.exports = __webpack_public_path__ + "img/arrecredihome2v_3_b.3bff8895.webp";